// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3caUS","notes":"Notes_notes__1rI39"};